module.exports = __webpack_public_path__ + "static/serv02-c715eafc018977b0e97c1a209ec70f70.png";